import React, { useState } from "react";
import {
  GraduationCap, Wallet, Home, Plane, ShieldCheck, Stamp, FlaskConical, BookOpen,
  Package, Users, Languages, MoreHorizontal, HelpCircle,
} from "lucide-react";
import { scholarships } from "@/data/scholarships";
import { benefitCategories, benefitCoverage } from "@/data/roadmap";
import { SectionTitle, Disclaimer } from "@/components/common";

const iconMap = { GraduationCap, Wallet, Home, Plane, ShieldCheck, Stamp, FlaskConical, BookOpen, Package, Users, Languages, MoreHorizontal };

const statusStyle = {
  "Fully Covered": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Partially Covered": "bg-teal-50 text-teal-700 border-teal-200",
  "Fixed Allowance": "bg-purple-50 text-[#6D28D9] border-purple-200",
  Reimbursement: "bg-blue-50 text-blue-700 border-blue-200",
  Conditional: "bg-amber-50 text-amber-700 border-amber-200",
  "Not Covered": "bg-slate-100 text-slate-500 border-slate-200",
  Unknown: "bg-slate-100 text-slate-400 border-slate-200",
};

export default function BenefitExplorer() {
  const [id, setId] = useState("chevening");
  const s = scholarships.find((x) => x.id === id);
  const coverage = benefitCoverage[id] || {};

  return (
    <div className="space-y-6">
      <SectionTitle title="Scholarship Benefit Explorer" desc="Pahami apa saja yang biasanya ditanggung oleh beasiswa." />

      <div className="flex flex-wrap gap-2">
        {scholarships.map((sc) => (
          <button key={sc.id} onClick={() => setId(sc.id)} data-testid={`benefit-tab-${sc.id}`}
            className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-all ${id === sc.id ? "border-[#7C3AED] bg-[#7C3AED] text-white" : "border-purple-100 bg-white text-slate-600 hover:bg-purple-50"}`}>
            {sc.name}
          </button>
        ))}
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {benefitCategories.map((cat) => {
          const c = coverage[cat.id];
          const Icon = iconMap[cat.icon] || MoreHorizontal;
          const status = c?.status || "Unknown";
          return (
            <div key={cat.id} data-testid={`benefit-${cat.id}`} className="rounded-2xl border border-purple-100 bg-white p-4 shadow-sm">
              <div className="flex items-start justify-between">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-purple-50 text-[#7C3AED]"><Icon className="h-4 w-4" /></span>
                <span className={`rounded-full border px-2 py-0.5 text-[11px] font-semibold ${statusStyle[status] || statusStyle.Unknown}`}>{status}</span>
              </div>
              <h3 className="mt-3 font-display text-sm font-bold text-slate-900">{cat.label}</h3>
              <p className="text-xs text-slate-400">{cat.desc}</p>
              {c ? (
                <div className="mt-2 space-y-0.5 text-xs text-slate-500">
                  <p>{c.note}</p>
                  <p className="flex items-center gap-1 text-slate-400"><HelpCircle className="h-3 w-3" /> Certainty: {c.certainty}</p>
                </div>
              ) : (
                <p className="mt-2 text-xs italic text-slate-400">Tidak ada data, perlu diverifikasi.</p>
              )}
            </div>
          );
        })}
      </div>

      <div className="rounded-2xl border border-purple-100 bg-[#FBFAFF] p-4 text-xs text-slate-500">
        Sumber: <b>{s.source_name}</b> ({s.source_type}) · Terverifikasi: {s.verified_date || "Belum"} ·{" "}
        <a href={s.source_url} target="_blank" rel="noopener noreferrer" className="font-semibold text-[#7C3AED] hover:underline">Verifikasi resmi →</a>
      </div>

      <Disclaimer>Kami tidak mengubah "may cover" menjadi "covered". Ketentuan pendanaan dipertahankan apa adanya, selalu cek dokumen resmi terbaru.</Disclaimer>
    </div>
  );
}
